// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","buttonDanger":"Button_buttonDanger__coUgU","buttonSuccess":"Button_buttonSuccess__1l3VC"};